<template>
  <pre class="code-block-component"><code><slot /></code></pre>
</template>

<script setup>
import { provide } from 'vue';

defineOptions({ inheritAttrs: false });

provide('insideCodeBlock', true);
</script>

<style scoped lang="scss" type="text/scss">
  .code-block-component {
    padding: .8rem 1.2rem;
    margin: 0 0 1.2rem;
    overflow-x: auto;
    font-size: .875em;
    line-height: 1.5;
    white-space: pre;
    background-color: map_get($grey, 'lighten-8');
    border: 1px solid $border-color;
    border-radius: $border-radius-sm;
  }
</style>
